var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-manage-companies" },
    [
      !_vm.loaded
        ? _c(
            "div",
            { staticClass: "layout-column flex-center loader" },
            [
              _c("rbv-loading", {
                attrs: { label: "Loading, please wait..." },
              }),
            ],
            1
          )
        : [
            _c("div", { staticClass: "header flex column" }, [
              _c("div", { staticClass: "flex row" }, [
                _c("div", { staticClass: "logo" }, [
                  _vm.userAccount && _vm.userAccount.account.logo
                    ? _c("img", {
                        attrs: { src: _vm.logo, alt: "Account Logo" },
                      })
                    : _c("div", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("business"),
                        ]),
                      ]),
                ]),
                _c("div", { staticClass: "flex column" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.userAccount && _vm.userAccount.account.name
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v(" " + _vm._s(_vm.module.title) + " "),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "flex row controls" },
                [
                  _c(
                    "div",
                    { staticClass: "flex row" },
                    [
                      _c(
                        "dropdown-actions",
                        {
                          staticClass: "light",
                          attrs: { items: _vm.sorters, align: "left" },
                          model: {
                            value: _vm.sortBy,
                            callback: function ($$v) {
                              _vm.sortBy = $$v
                            },
                            expression: "sortBy",
                          },
                        },
                        [
                          _c("template", { slot: "value" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("sort"),
                            ]),
                            _vm._v(" Sort By: "),
                            _c("b", [_vm._v(_vm._s(_vm.sortBy.label))]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.isFromRfpManager
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: { click: _vm.openRfpManager },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_back"),
                            ]),
                            _vm._v(" Back to RFP Manager "),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: { click: _vm.openUsersAndPermissions },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("people"),
                            ]),
                            _vm._v(" Users & Permissions "),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm.isAdmin
                    ? _c(
                        "button",
                        {
                          staticClass: "button create",
                          on: { click: _vm.createCompany },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("playlist_add"),
                          ]),
                          _vm._v(" Add New Company "),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c("rows", {
              attrs: {
                accounts: _vm.sortedAndSearched,
                "user-account": _vm.userAccount || {},
                "current-user-is-admin": _vm.isAdmin,
              },
              on: {
                edit: _vm.edit,
                editLogo: _vm.editLogo,
                assignments: _vm.assignments,
                drop: _vm.drop,
                editPrimaryContact: _vm.editPrimaryContact,
                hotelDirectory: _vm.hotelDirectory,
                rateLoadingInformation: _vm.rateLoadingInformation,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }